import { render, staticRenderFns } from "./NewRecord.vue?vue&type=template&id=926d6c52&"
import script from "./NewRecord.vue?vue&type=script&lang=js&"
export * from "./NewRecord.vue?vue&type=script&lang=js&"
import style0 from "./NewRecord.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports